import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Events/hooks/useEvent.ts
/**
* Get a single Event and the EventType data
* @param args
* @param opts
*/
function useEvent(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Events.GetEvent.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: opts.fire || !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useEvent };

//# sourceMappingURL=useEvent.js.map